import React from 'react';
import Icon, { IconProps } from '../Icon';

const PlusIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M50 25C50 38.7848 38.7848 50 25 50C11.2152 50 0 38.7848 0 25C0 11.2152 11.2152 0 25 0C38.7848 0 50 11.2152 50 25ZM47.9166 24.9999C47.9166 12.3636 37.6362 2.08324 24.9999 2.08324C12.3636 2.08324 2.08324 12.3636 2.08324 24.9999C2.08324 37.6362 12.3636 47.9166 24.9999 47.9166C37.6362 47.9166 47.9166 37.6362 47.9166 24.9999Z"
          fill="currentColor"
        />
        <path
          d="M11.8926 26.0417H23.9583V38.1073C23.9583 38.6826 24.4242 39.149 24.9999 39.149C25.5757 39.149 26.0416 38.6826 26.0416 38.1073V26.0417H38.1072C38.683 26.0417 39.1489 25.5753 39.1489 25C39.1489 24.4248 38.683 23.9584 38.1072 23.9584H26.0416V11.8927C26.0416 11.3175 25.5757 10.8511 24.9999 10.8511C24.4242 10.8511 23.9583 11.3175 23.9583 11.8927V23.9584H11.8926C11.3169 23.9584 10.851 24.4248 10.851 25C10.851 25.5753 11.3169 26.0417 11.8926 26.0417Z"
          fill="currentColor"
        />
      </svg>
    </Icon>
  );
};
export default PlusIcon;
